var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "c-button-wrapper btn",
      class: `btn-${_setup.btnVariant} btn-${_vm.size}`,
      attrs: { type: _vm.type, disabled: _vm.disabled },
      on: {
        click: function ($event) {
          return _setup.emit("click", $event)
        },
        mousedown: function ($event) {
          return _setup.emit("mousedown", $event)
        },
        mouseup: function ($event) {
          return _setup.emit("mouseup", $event)
        },
      },
    },
    [
      !_setup.slots.default || _vm.prioritizeContent
        ? [
            _vm.icon
              ? _c("font-awesome-icon", {
                  class: { "mr-2": _vm.text && _vm.text.length },
                  attrs: { icon: _vm.icon },
                })
              : _vm._e(),
            _vm._v("\n        " + _vm._s(_vm.text) + "\n    "),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }